// extracted by mini-css-extract-plugin
export default {"item":"BarTooltip_item__EX8Pu","text":"BarTooltip_text__EgHQ9","name":"BarTooltip_name__QbjmF","square":"BarTooltip_square__T81RX"};